'use client';

import { useState, useLayoutEffect } from 'react';

export type BreakpointName = 'xsm' | 'pre-mobile' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';

const breakpoints: Record<BreakpointName, number> = {
  'xsm': 360,
  'pre-mobile': 450,
  'sm': 640,
  'md': 768,
  'lg': 1024,
  'xl': 1280,
  '2xl': 1366,
  '3xl': 1920,
};

export function useIsGreaterThan(breakpoint: BreakpointName): boolean {
  const breakpointValue = breakpoints[breakpoint];

  const [isGreaterThan, setIsGreaterThan] = useState<boolean>();

  useLayoutEffect(() => {
    const handleResize = () => {
      setIsGreaterThan(window?.innerWidth >= breakpointValue);
    };

    handleResize();
    window?.addEventListener('resize', handleResize);

    return () => {
      window?.removeEventListener('resize', handleResize);
    };
  }, [breakpointValue]);

  return isGreaterThan ?? true;
}
